import React from 'react';
import { ClockIcon, FlameIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { urgency } from '../data/content';
interface CountdownPanelProps {
  showScarcity?: boolean;
}
export function CountdownPanel({
  showScarcity = true
}: CountdownPanelProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <div className="mx-auto w-full max-w-narrow text-center" data-id="element-33" data-mp="q5iga78gfli2">
      <p className="inline-flex items-center gap-2 font-display text-sm font-bold uppercase tracking-[0.2em] text-gold-400 md:text-base" data-id="element-34" data-mp="q3nrghu2b98p">
        <ClockIcon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-35" data-mp="h4k7lbn2mpt5" />
        {urgency.title}
      </p>

      <div className="mt-7 flex items-start justify-center gap-5 md:gap-9" role="timer" data-id="element-36" data-mp="26jqnmuknlo94">
        {units.map(unit => <div key={unit.label} className="flex flex-col items-center" data-id="element-37" data-mp="2bhs9toddm3ot">
            <span className="min-w-[3.5rem] rounded-xl bg-night-700 px-3 py-2 font-display text-4xl font-bold tabular-nums leading-none tracking-tight text-ink ring-1 ring-white/5 md:min-w-[5rem] md:px-4 md:py-3 md:text-6xl" data-id="element-38" data-mp="1lgf1uq474o33">
              {unit.value}
            </span>
            <span className="mt-2.5 text-xs font-semibold uppercase tracking-[0.22em] text-faint" data-id="element-39" data-mp="1q7x199qkmgly">
              {unit.label}
            </span>
          </div>)}
      </div>

      {showScarcity && <div className="mt-8" data-id="element-40" data-mp="yh0r4gvwaq2d">
          <p className="mx-auto max-w-xl text-muted" data-id="element-41" data-mp="yhslxpho4jrl">{urgency.body}</p>
          <p className="mt-6 inline-flex items-center gap-2 rounded-xl bg-indigo-500/12 px-4 py-2.5 text-sm font-semibold text-indigo-300 ring-1 ring-indigo-400/25 md:text-base" data-id="element-42" data-mp="1cg8p56gbns4z">
            <FlameIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-43" data-mp="2nvp1kckxdxxr" />
            {urgency.note}
          </p>
        </div>}
    </div>;
}